<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <!--ヘッダーにmax-width1920がいらない時はここを削除。対応する</div>も一緒に-->
      <div class="m-width1920">
        <div class="d-flex align-items-center">
          <!--ここまで↑-->
          <a class="navbar-brand" href="/">
            <img
              class="navbar-logo"
              src="@/assets/img/logo/treasure_logo.png"
              alt="野球グラブのオーダーメイドシミュレーション | Treasure ロゴ"
            />
          </a>
          <div class="nav-link">
            プライバシーポリシー
          </div>
        </div>
      </div>
    </nav>
    <!--固定ヘッダー-->

    <div class="container mt-5 confirmation-main text-color-fff">
      <h2 class="text-center">プライバシーポリシー</h2>
      <p class="mt-5">
        有限会社間瀬土木（以下「当社」といいます。）は、お客様の個人情報保護の重要性を認識し、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）を遵守するとともに、以下のプライバシーポリシーに従い、適切な取扱い及び保護に努めます。
      </p>

      <div class="mt-5">
          <h5 class="mt-5">1. 個人情報の収集について</h5>
          <p>当社は、本サービスのご利用にあたり、以下の個人情報をお客様からお預かりする場合があります。</p>
          <ul>
            <li>氏名</li>
            <li>メールアドレス</li>
            <li>ご住所</li>
            <li>電話番号</li>
          </ul>
          <p>
            個人情報の収集は、利用目的を明示した上で、その目的を達成するために必要な範囲において、適法かつ公正な手段により行います。
          </p>

          <h5 class="mt-5">2. 個人情報の利用目的</h5>
          <p>お預かりした個人情報は、以下の目的に限り利用いたします。</p>
          <ul>
            <li>オーダーグローブのご注文内容の確認および製作・発送のため</li>
            <li>ご注文に関するご連絡、お問い合わせへの返答のため</li>
            <li>当社サービスに関する重要なお知らせのため</li>
          </ul>

          <h5 class="mt-5">3. 個人情報の安全管理</h5>
          <p>
            当社は、お客様の個人情報への不正アクセス、紛失、改ざん、漏洩等のリスクに対して、適切かつ合理的な安全対策を実施します。また、個人情報の取扱いを外部に委託する場合は、委託先に対して必要かつ適切な監督を行います。
          </p>
          <p>
            なお、本サービスではお客様へのメール送信に外部のメール送信サービスを利用しており、メール送信に必要な範囲でお客様の情報が当該サービスを経由します。利用する外部サービスは適切な安全管理措置を講じた事業者を選定しています。
          </p>

          <h5 class="mt-5">4. 第三者への提供</h5>
          <p>当社は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供・開示することはありません。</p>
          <ul>
            <li>法令に基づき開示が必要な場合</li>
            <li>裁判所、警察等の公的機関から開示を求められた場合</li>
            <li>ご注文の製作・発送業務の委託に伴い、業務委託先へ提供する場合</li>
            <li>メール送信サービスを経由してご連絡をお届けする場合（送信に必要な範囲に限ります）</li>
          </ul>

          <h5 class="mt-5">5. 個人情報の開示・訂正・利用停止等</h5>
          <p>
            お客様ご自身の個人情報について、開示・訂正・追加・削除・利用停止等のご要望がある場合は、本人確認の上、法令に従い遅滞なく対応いたします。
          </p>

          <h5 class="mt-5">6. Cookie（クッキー）およびアクセス解析ツールの利用</h5>
          <p>
            当社は、サービス向上を目的として、Cookieおよびアクセス解析ツール（Googleアナリティクス等）を利用する場合があります。これらのツールによりデータを収集することがありますが、個人を特定する情報は含まれません。Cookieを無効化したい場合は、お使いのブラウザの設定より無効化することができます。なお、無効化した場合、一部機能がご利用いただけなくなる場合があります。これらのツールの利用を開始する際には、本プライバシーポリシーを改定し、本サイト上でお知らせいたします。
          </p>

          <h5 class="mt-5">7. プライバシーポリシーの変更</h5>
          <p>
            当社は、個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めます。本プライバシーポリシーは、必要に応じて変更することがあります。変更した場合は、本サイト上にて通知いたします。
          </p>

          <h5 class="mt-5">8. お問い合わせ</h5>
          <p>個人情報の取扱いに関するお問い合わせは、下記までご連絡ください。</p>
          <p>
            有限会社間瀬土木<br />
            Ｅメール：{{ mailAddress }}
          </p>

          <div class="mt-5 text-center form-row mt-4 form__btn_gap">
            <div class="col">
              <button
                type="button"
                class="w-50 form-btn-block form-btn-secondary btn btn-block"
                @click="$router.back()"
              >
                戻る
              </button>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  p,
  li {
    font-size: 14px;
  }
</style>

<script>
export default {
  computed: {
    mailAddress() {
      return ["s.mase", "ireiza.jp"].join("@");
    },
  },
};
</script>
